import React from "react";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "../data/constants";
import { buildWhatsAppUrl } from "../lib/whatsapp";

const DEFAULT_MSG =
  "Hi Shoolin Digital Services 👋, I came across your website and would love to chat about a project.";

export default function WhatsAppFAB() {
  const href = buildWhatsAppUrl(COMPANY.whatsapp, DEFAULT_MSG);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed z-[60] bottom-5 right-5 md:right-6 inline-flex items-center gap-3 pl-4 pr-5 py-3 bg-[#25D366] text-black font-bold uppercase tracking-[0.18em] text-xs hover:bg-[#1FBA59] transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-[#25D366]/30"
    >
      <MessageCircle className="w-5 h-5" strokeWidth={2.4} />
      <span className="hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
